import React, { PureComponent } from 'react';
import Loaders from 'loaders';

import TradeDetails from './TradeDetails';
import TradeFilters from './TradeFilters';

class TradesView extends PureComponent {
  render() {
    let {
      groups,
      context,
      gotToTrade,
      filtersFormState,
      page,
      nextPage,
      previousPage,
      toggle,
      expanded,
      downloadTrades,
    } = this.props;

    return (
      <div className="admin-trades-view">
        <TradeFilters {...this.props}/>
        <div className="button-toolbar">
          <button
            className="button"
            onClick={() => downloadTrades()}
            title="Will export a max of 1000 records based on your filters"
          >
            Export
          </button>
        </div>
        {groups ? (
          <table>
            <thead>
            <tr>
              <th>Trade ID</th>
              <th>Account</th>
              <th>Date</th>
              <th>Carrier Info</th>
              <th>Offer</th>
              <th>Type</th>
              <th>$</th>
              <th>Status</th>
              <th>Fraud</th>
              <th>duplicates</th>
              <th>Actions</th>
              <th></th>
            </tr>
            </thead>

            {Object.keys(groups).map((groupKey)=>{
              const trades = groups[groupKey];
              const titles = {
                help: 'Help needed',
                blocked: 'Blacklisted / Disputed',
                flagged: 'Flagged',
              };
              const title = titles[groupKey];
              let items = [];
              if(title && trades.length){
                items.push((
                  <thead key={groupKey}>
                    <tr className={`trade-group-header ${groupKey}`}>
                      <th colSpan="10">
                        {title}
                      </th>
                    </tr>
                  </thead>
                ))
              }
              items = items.concat(trades.map((trade, i)=>(
                <TradeDetails
                  isEven={i%2}
                  className={groupKey}
                  key={trade.tradeId + '-' + groupKey}
                  expanded={expanded[trade.tradeId]}
                  toggle={()=>toggle(trade)}
                  trade={trade}
                  page={page}
                  filtersFormState={filtersFormState}
                  context={context}
                  gotToTrade={gotToTrade}
                />
              )));
              return items;
            }).reduce((acc, item)=>acc.concat(item), [])}
            <tbody>
            <tr>
              <td colSpan="11">
                <ul className="pagination">
                  <li className={page <= 1 ? 'pagination-previous disabled' : 'pagination-previous'}>
                    {page > 1  ? (
                      <a onClick={e=>{
                        e.preventDefault();
                        previousPage();
                      }}>Previous</a>
                    ) : 'Previous'}

                  </li>
                  <li>{page}</li>
                  <li className="pagination-next">
                    <a onClick={e=>{
                      e.preventDefault();
                      nextPage();
                    }}>Next</a>
                  </li>
                </ul>
              </td>
            </tr>

            </tbody>
          </table>
        ) : (
          <div>
            <Loaders width="50" height="50"/>
          </div>
        )}

      </div>
    );
  }
}

export default TradesView;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/Trades.view.js